import { define } from '../../define.js';
import { Tree } from './tree.js';
export * from './tree.js';
define('tree', Tree);
